export interface RiskAxisScore {
  score: number;
  justification: string;
  evidence: string[];
}

export interface RiskAxes {
  severity: RiskAxisScore;
  likelihood: RiskAxisScore;
  timeSensitivity: RiskAxisScore;
}

export interface RiskTypeDetail {
  score: number;
  justification: string;
  evidence: string[];
}

export interface RiskTypes {
  financialRisk: RiskTypeDetail;
  complianceRisk: RiskTypeDetail;
  operationalRisk: RiskTypeDetail;
  reputationalRisk: RiskTypeDetail;
}

export type OverallRiskIndicator = "HIGH" | "MEDIUM" | "MODERATE" | "LOW" | "UNKNOWN";

export const PROCESS_DECISION_DO_NOT_PROCESS = "DO_NOT_PROCESS" as const;

export interface RiskAnalysisData {
  overallIndicator: OverallRiskIndicator;
  overallJustification: string;
  evidence: string[];
  axes: RiskAxes;
  riskTypes: RiskTypes;
  recommendations: string[];
}

export interface AfterCallRisk {
  evidence: string[];
}

export interface AgentPerformanceData {
  summary: string;
  afterCallRisk: AfterCallRisk;
  beforeCallRisk: Record<string, number>;
}

export interface RiskAnalysisContent {
  riskAnalysis?: RiskAnalysisData;
  agentPerformance?: AgentPerformanceData;
  process_decision?: string;
  reason_description?: string;
}

export type RiskDimensionId = "financial" | "compliance" | "operational" | "reputational";

export interface RiskDimensionConfig {
  id: RiskDimensionId;
  name: string;
  riskTypeKey: keyof RiskTypes;
}
